/** GoEasy 客服 iframe 静态资源目录（勿与后台路由 /customer-service/* 共用路径） */
export const CS_EMBED_BASE = 'goeasy-cs'

export function csEmbedIndexUrl (hash = '#/conversations') {
  const base = process.env.BASE_URL || '/'
  const prefix = base.endsWith('/') ? base : `${base}/`
  return `${prefix}${CS_EMBED_BASE}/index.html${hash}`
}

export function csEmbedStaticUrl (relativePath) {
  const name = String(relativePath || '').replace(/^\//, '')
  return `/${CS_EMBED_BASE}/static/${name}`
}

/**
 * 跳转在线客服工作台；可带 customerId 打开指定用户会话（客服主动聊）。
 * @param {object} [options]
 * @param {string|number} [options.customerId] App 用户 ID（GoEasy customerId）
 * @param {string} [options.name] 展示昵称
 * @param {string} [options.avatar] 头像 URL
 * @param {boolean} [options.autoAccept=true] 进入后自动「主动接入」
 */
export function navigateToCsWorkbench (router, store, options = {}) {
  const routers = (store && store.getters && store.getters.routers) || []
  const root = routers.find(r => r.path === '' || r.path === '/')
  const children = (root && root.children) || []
  let path = ''
  for (const child of children) {
    const p = child.path || ''
    if (p.includes('workbench')) {
      path = p.startsWith('/') ? p : `/${p}`
      break
    }
  }
  if (!path) {
    path = '/customer-service/workbench'
  }
  const query = {}
  const customerId = options.customerId != null ? String(options.customerId).trim() : ''
  if (customerId) {
    query.customerId = customerId
    if (options.name) query.name = String(options.name)
    if (options.avatar) query.avatar = String(options.avatar)
    if (options.autoAccept === false) {
      query.autoAccept = '0'
    } else {
      query.autoAccept = '1'
    }
  }
  const loc = { path, query }
  const resolved = router.resolve(loc)
  if (resolved.route.matched && resolved.route.matched.length) {
    return router.push(loc).catch(() => {})
  }
  return router.push({ name: 'Workbench', query }).catch(() => {})
}
